<template>
    <div><img v-if="btnFlag" class="go_top" src="../assets/shopmallimg/top.svg" @click="backTop"></div>
</template>
<script>
export default {
    name: 'top',
    data(){
        return {
            btnFlag: false,
        }
    },
    mounted(){
        window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed(){
        window.addEventListener('scroll', this.scrollToTop)
    },
    methods:{
        backTop(){
            const that = this
            let timer = setInterval(() => {
                let ispeed = Math.floor(-that.scrollTop / 5)
                document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                if (that.scrollTop === 0) {
                clearInterval(timer)
                }
            }, 16)
        },
        scrollToTop () {
            const that = this
            let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            that.scrollTop = scrollTop
            if (that.scrollTop > 60) {
                that.btnFlag = true
            } else {
                that.btnFlag = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.go_top{
    width: 0.4rem;
    height: 0.4rem;
    position: fixed;
    right: 0.12rem;
    bottom: 1rem;
}
</style>